import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as MethodOptionCategoryQueries from '../method-option-category/method-option-category.selectors';
import { NAME, State, selectAll, selectEntities, selectIds, selectTotal } from './method-option.reducer';

export const selectMethodOptionState = createFeatureSelector<State>(NAME);

export const getError = createSelector(selectMethodOptionState, (state: State) => state.error);

export const getLoaded = createSelector(selectMethodOptionState, (state: State) => state.loaded);

export const getAll = createSelector(selectMethodOptionState, selectAll);

export const getCount = createSelector(selectMethodOptionState, selectTotal);

export const getIds = createSelector(selectMethodOptionState, selectIds);

export const getAllEntities = createSelector(selectMethodOptionState, selectEntities);

export const getGroupedByCategory = createSelector(
  MethodOptionCategoryQueries.getAll,
  getAll,
  (categories, options) =>
    categories
      .map((category) => ({
        category,
        options: options
          .filter((option) => option.methodOptionCategoryId === category.id)
          .sort((a, b) => (a.sequence ?? 0) - (b.sequence ?? 0)),
      }))
      .filter((group) => group.options.length > 0)
);

export const getGroupedByCategoryForFilter = createSelector(getGroupedByCategory, (groups) =>
  groups
    .map((group) => ({
      ...group,
      options: group.options.filter((option) => option.usableAsFilter !== false),
    }))
    .filter((group) => group.options.length > 0)
);

export const isBookLoaded = (props: { bookId: number }) =>
  createSelector(selectMethodOptionState, (state: State) => !!state.loadedForBook[props.bookId]);
